<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  <div class="content-container">
    <div class="title d-inline-flex w-100">
      <mwp-text-translate text="COMPANY RESULTS" jsonKey="companyResults" />
    </div>
    <div class="content">
      <form [formGroup]="agentControlForm">
        <div class="d-flex flex-wrap row mb-3">
          <div class="col-3">
            <mwp-dropdown [form]="agentControlForm" nameForControl="brokerId" [data]="brokers" keyText="name" keyValue="id" (emitSelected)="brokerChange($event)" labelName="Select Broker" />
          </div>
          <div class="col-3">
            @if (agents?.length == 0) {
            <div>
              <mwp-text-translate text="No Agents For Broker" jsonKey="agentAssignNoAgentsForBroker" />
            </div>
            }
            @if (agents?.length > 0) {
            <div>
              <mwp-dropdown [form]="agentControlForm" nameForControl="agentID" [data]="agents" keyText="name" keyValue="agentID" (emitSelected)="agentChange($event)" labelName="Select Agent" />
            </div>
            }
          </div>
          <div class="col-3 p-3"></div>
        </div>
      </form>
      @if (companyForm) {
        <div class="mb-3">
          <mwp-table-formarray [form]="companyForm" [arrayName]="companyFormArrayName" [tableColumns]="companyColumns" [dataSource]="companyMatTableData" />
        </div>
      }
      @if ( !isAssign) {
      <div class="d-inline-flex justify-content-end w-100 p-3">
        @if (companyForm) {
        <button class="mwp-button-delete me-4" [disabled]="!companyForm.valid" (click)="unassignCompanies()">
          <mwp-text-translate text="Remove Assignments" jsonKey="agentAssignRemoveAssignments" />
        </button>
        }
        <button class="mwp-button-save" [disabled]="!selectedAgentId" (click)="buildAssignForm()">
          <mwp-text-translate text="Assign Companies" jsonKey="agentAssignAssignCompanies" />
        </button>
      </div>
      }
      @if (isAssign) {
      <div class="d-inline-flex justify-content-end w-100 p-3">
        <button class="mwp-button-delete me-4" (click)="buildRemoveForm(false)">
          <mwp-text-translate text="Unassign Companies" jsonKey="agentAssignUnassignCompanies" />
        </button>
        <button class="mwp-button-save" [disabled]="!companyForm.valid" (click)="assignCompanies()">
          <mwp-text-translate text="Assign Companies" jsonKey="assignAgentsToCompany" />
        </button>
      </div>
      }
    </div>
  </div>
</div>